export class serie{
    id:string;
    campo:string;
    data_da:string;
    data_a:string;
    tiratori;
    punteggi;
    stato;
    tiratore1;
    tiratore2;
    tiratore3;
    tiratore4;
    tiratore5;    
    tiratore6;
    id_gara;
}